import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppErrorBoundary, bootstrapObservability } from '@ubus/shared';
import App from './App';
import MobileLocaleProvider from './components/MobileLocaleProvider';
import './i18n';
import './index.css';

bootstrapObservability('driver-h5');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <MobileLocaleProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MobileLocaleProvider>
    </AppErrorBoundary>
  </React.StrictMode>
);
